import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'
import Text from './Text'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    flexGrow: 1,
  },
  text: {
    fontSize: 14,
  },
  title: {
    color: colors.strongGray,
    fontSize: 14,
    fontFamily: 'Inter-Bold',
    fontWeight: 'bold',
  },
}
const ConsentText = ({ title, text }) => (
  <div style={styles.container}>
    <Text style={{ color: colors.strongGray, ...styles.text }}>
      <span style={styles.title}>{title}</span>
      {text}
    </Text>
  </div>
)

ConsentText.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default ConsentText
